import { FinanceValueObjectsContactTypeEnum } from 'generated/resources/datatable.graphql'
import { ContactFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import ContactForm from './ContactForm'

interface ContactFormModalProps {
  onClose?: () => void
  contact?: ContactFragment
  contactType: FinanceValueObjectsContactTypeEnum
}

const ContactFormModal = ({ contact, onClose, contactType }: ContactFormModalProps) => {
  const title =
    contact?.id !== undefined && contact?.id !== '0'
      ? i18n.t('finance.contacts.contact_form.update_contact.title')
      : i18n.t('finance.contacts.contact_form.new_contact.title')
  return (
    <Modal illustration="document-edit" title={title} onClose={onClose}>
      <ContactForm contact={contact} onSuccess={onClose} contactType={contactType} />
    </Modal>
  )
}

export default ContactFormModal
